/**
 * Ch Swatch Talles - JavaScript
 * Maneja la funcionalidad de agregar variantes al carrito desde los swatches de tallas
 * Autor: Carlos Hernandez
 */

// Función global para ch-swatch-talles - disponible en todos los contextos
if (typeof window.addVariantToCart === 'undefined') {
  window.addVariantToCart = function(element) {
    const variantId = element.getAttribute("data-variant-id");
    if (!variantId) return;

    element.classList.add("loading"); // Agregar clase de carga visual

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(cart => {
        // Producto agregado exitosamente

        // Deseleccionar el radio button después de agregar al carrito
        const input = document.getElementById(element.getAttribute("for"));
        if (input) {
          input.checked = false;
        }

        // Publicar evento de actualización del carrito
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'swatch', cartData: cart });
        }

        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) {
          cartDrawer.classList.remove("is-empty"); // Remover la clase si el carrito estaba vacío
          cartDrawer.classList.add("active");
          document.body.classList.add("overflow-hidden");

          // Forzar actualización del contenido del `cart-drawer`
          if (typeof routes !== 'undefined' && routes.cart_url) {
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
              .then(response => {
                if (!response.ok) throw new Error('Failed to fetch cart');
                return response.text();
              })
              .then(responseText => {
                const parser = new DOMParser();
                const newDocument = parser.parseFromString(responseText, "text/html");
                const newCartContent = newDocument.getElementById("CartDrawer");

                if (newCartContent) {
                  const currentCartDrawer = document.getElementById("CartDrawer");
                  if (currentCartDrawer) {
                    currentCartDrawer.innerHTML = newCartContent.innerHTML;
                  }
                }
              })
              .catch(error => {
                console.warn("Error al actualizar cart drawer:", error);
              });
          }
        }
      })
      .catch(error => {
        console.error("Error al agregar producto:", error);
        alert("Hubo un problema al agregar el producto. Inténtalo de nuevo.");
      })
      .finally(() => {
        element.classList.remove("loading"); // Remover clase de carga
      });
  };
  
  // También definir sin window para compatibilidad con onclick inline
  if (typeof addVariantToCart === 'undefined') {
    var addVariantToCart = window.addVariantToCart;
  }
}
